import gql from 'graphql-tag';

export default gql`
  query getVouchersForProduct($itemUuid: String!) {
    getVouchersForProduct(itemUuid: $itemUuid) {
      data {
        type
        value
      }
    }
  }
`;
